import React, { useState, useEffect } from "react" ;
import UsersAppSidebar from "./Sidebar/ApprovalsAppSidebar";
import UsersAppBody from "./Body/ApprovalsAppBody";

const WieldyApplicationModuleApprovals = (props) =>
{
    const [ height, setHeight ] = useState ( props.height ) ;
    const [ width, setWidth] = useState ( props.width ) ;
    const pageStyle = { height: '' + (+height-1) + 'px' } ;

    useEffect(() => {
        setHeight(props.height);
        setWidth(props.width);
    }, [props.height, props.width]);

    return (
        <div className="row">
            <div className="col-xl-12">

                <div className="dt-module" style={pageStyle}>
                    <UsersAppSidebar title={'To Approve'} iconName={'icon-important'} height={height} width={width}/>
                    <UsersAppBody height={height}/>
                </div>
            </div>
        </div>
    );
}

export default WieldyApplicationModuleApprovals;